import { Component } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ArrivePlanService } from '../../../service/arrive-plan/arrive-plan.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa1910.component.html',
  styleUrls: ['wa1910.component.css']
})
export class Wa1910Component {
  public componentTitle = 'WA1910:入荷データアップロード';

  // grid for error messages
  public isError = false;
  public gridOptions: GridOptions;
  public rowData: any[];

  public owners: any;
  public ownerId: number;
  private file: File;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(
    private router: Router,
    private arrivePlanService: ArrivePlanService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridOptions = <GridOptions>{
      enableFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems
    };
    this.gridOptions.columnDefs = [
      {
        headerName: 'エラー内容',
        field: 'message',
        width: 1000
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        this.working = false;
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.ownerId = this.owners[0]['ownerId'];
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'CSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  fileChange(event) {
    console.log('ok');
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  upload() {
    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください';
      return;
    }
    if (this.file === undefined) {
      this.errorInfo = 'ファイルを選択してください';
      return;
    }
    this.working = true;
    this.arrivePlanService
      .upload(this.file, this.ownerId)
      .then(outputJson => {
        this.working = false;
        this.isError = false;
        this.file = undefined;
        // this.dialogsService.info('完了', 'アップロードが完了しました');
      })
      .catch(error => {
        this.working = false;
        this.isError = true;
        this.file = undefined;
        this.rowData = this.commonService.getErrorList(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1910/wa1910.component.ts